import React from 'react';
import { Navigation } from '../components/Navigation';
import { AboutSection } from '../components/AboutSection';
import { WhyChooseUsSection } from '../components/WhyChooseUsSection';
import { Footer } from '../components/Footer';

const AboutPage = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <div className="pt-20">
        <AboutSection />
        <WhyChooseUsSection />
      </div>
      <Footer />
    </div>
  );
};

export default AboutPage;
